import { AndroidOutlined, ChromeOutlined, UserAddOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, message, Modal, Row, Select, Space, Table } from 'antd';
import { useEffect, useState } from 'react';
import { GroupService } from '../services/Group';
import { AgentService } from '../services/Agent';

const { Option } = Select;
const { confirm, warn } = Modal;
const Agent = () => {
    const [data, setData] = useState(new Array<API.Project>());
    const [currentRecord, setCurrentRecord] = useState<any>(null);
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const layout = {
        labelCol: {
            span: 8,
        },
        wrapperCol: {
            span: 16,
        },
    };



    const update = async () => {
        let v = await AgentService.listAll()
        v.forEach((v2: any) => {
            v2.key = v2.id
        })
        setData(v);

    }
    const create = async function () {

        form.resetFields();
        setCurrentRecord(null);
        form.setFieldsValue({ type: "tcpkp" })
        setIsModalVisible(true)


    }
    const modify = async function (record: any) {
        setCurrentRecord(record);
        form.resetFields();
        form.setFieldsValue(record)
        setIsModalVisible(true);
    }

    const remove = async function (record: any) {
        confirm(
            {
                title: "提示",
                content: "确定要删除吗？",
                okText: "确定",
                cancelText: "取消",
                onOk: () => {
                    AgentService.Delete(record.id).then((v) => {
                        if (v.code != 0)
                            return Modal.warn({ title: "警告", content: v.message })

                        update();
                    });
                }
                ,
                onCancel: () => {
                    Modal.destroyAll();
                }
            });
    }



    const handleOk = () => {
        async function process() {

            let v = form.getFieldsValue();
            if (typeof (v.ip) == 'undefined') {
                Modal.info({
                    title: "提示",
                    content: "IP不能为空!",
                    onOk: () => {

                    }
                })
                return
            }

            if (typeof (v.name) == 'undefined') {
                Modal.info({
                    title: "提示",
                    content: "名称不能为空!",
                    onOk: () => {

                    }
                })
                return
            }
            if (currentRecord) {
                v.id = currentRecord.id;
                await AgentService.Update(v.id, v.name);
                message.info("更新成功");
            } else {
                await AgentService.Add(v);
                message.info("代理新建成功");
            }
        }

        form.validateFields().then(() => {
            process().then(() => {
                setIsModalVisible(false);
                update().then(() => {
                    GroupService.listAll();
                });

            }).catch((e) => {
                warn({ title: "提示", content: e });
                console.log(e)
            })
        }).catch((e) => {
            throw e
        })


    };

    useEffect(() => {
        update();
    }, [])

    const columns = [
        {
            title: '分组ID',
            dataIndex: 'id',
            key: 'id'

        },
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name'

        },
        {
            title: 'IP',
            dataIndex: 'ip',
            key: 'ip'

        },
        {
            title: '类型',
            dataIndex: 'type',
            key: 'type'

        },
        {
            title: '操作',
            key: 'action',
            render: (text: any, record: any) => (
                record.name == "admin" ?
                    <Space size="middle">
                    </Space>
                    :
                    <Space size="middle">
                        <a hidden={true} onClick={(e) => { modify(record); }}>修改</a>
                        <a onClick={(e) => { remove(record); }}>删除</a>
                    </Space>
            ),
        },
    ];

    return <div style={{ margin: 0 }}>
        <Modal title="创建新的代理" visible={isModalVisible} onOk={handleOk} onCancel={() => setIsModalVisible(false)} cancelText="取消" okText="确定">
            <Form
                {...layout}
                name="basic"
                form={form}

            >
                <Form.Item
                    label="名称"
                    name="name"
                    rules={[
                        {
                            required: true,
                            message: '不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="ip"
                    name="ip"
                    rules={[
                        {
                            required: true,
                            message: '不能为空!',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="类型"
                    name="type"
                >
                    <Select >
                        <Option vkey={"tcpkp"} value="tcpkp">tcpkp</Option>
                        <Option vkey={"tcp232"} value="tcp232">tcp232</Option>
                    </Select>
                </Form.Item>

            </Form>
        </Modal>
        <h2 className='title'>代理管理</h2>
        <Row style={{ marginBottom: 5 }}>
            <Col>
                <Button type="primary" icon={<ChromeOutlined />} onClick={() => create()}>新建</Button>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <Table dataSource={data} pagination={false} columns={columns} />;
            </Col>
        </Row>
    </div>

};

export default Agent;